import { setupGoogleAnalytics } from './piiScrubber';
const GOOGLE_ANALYTICS_SCRIPT_LOCATION = 'https://www.google-analytics.com/analytics.js';
/**
 * Method to check whether Google Analytics has already been loaded
 * or is in the process of loading.
 *
 * @return {Boolean}
 * Whether Google Analytics is already loaded.
 */ const googleAnalyticsIsPresent = ()=>{
    return(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    window.hasOwnProperty('ga') && typeof window.ga === 'function' || document.querySelectorAll(`script[src="${GOOGLE_ANALYTICS_SCRIPT_LOCATION}"]`).length > 0);
};
/**
 * Takes `{foo: true, bar: false, baz: true}` and returns `'foo,baz'`
 *
 * @method stringifyFlags
 * @private
 * @param flagsObj {Object<Boolean>}
 * @returns {String}
 */ const stringifyFlags = (flagsObj)=>{
    if (typeof flagsObj !== 'object') {
        return '';
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flagsArr = [];
    for(const flagName in flagsObj){
        if (flagsObj[flagName] === true) {
            flagsArr.push(flagName);
        }
    }
    return flagsArr.join(',');
};
/**
 * This method injects the shared Google Analytics script for Stripe
 * domains. It listens to a few options on whether to automatically track
 * or not. It allows pass-through configuration from the outside world via
 * the `ga` property in the global config.
 *
 * @param {Object} [config={}]
 * This config object can be used to set GA Track Options and turn on or
 * off default pageview tracking.
 */ export const injectGoogleAnalytics = (config = {})=>{
    // Use the Google Analytics injection code directly. It's asynchronous, so we start loading it
    // first, and can comfortably configure it directly afterwards.
    if (!googleAnalyticsIsPresent()) {
        /* eslint-disable */ (function(i, s, o, g, r, a, m) {
            // @ts-ignore GA code
            i['GoogleAnalyticsObject'] = r;
            // @ts-ignore GA code
            i[r] = // @ts-ignore GA code
            i[r] || function() {
                // @ts-ignore GA code
                (i[r].q = i[r].q || []).push(arguments);
            }, // @ts-expect-error GA code
            i[r].l = 1 * new Date();
            // @ts-expect-error GA code
            a = s.createElement(o), m = s.getElementsByTagName(o)[0];
            // @ts-expect-error GA code
            a.async = true;
            // @ts-expect-error GA code
            a.src = g;
            // @ts-expect-error GA code
            m.parentNode.insertBefore(a, m);
        })(window, document, 'script', GOOGLE_ANALYTICS_SCRIPT_LOCATION, 'ga');
    /* eslint-enable */ }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (window.ga) {
        // legacyCookieDomain per
        // https://developers.google.com/analytics/devguides/collection/upgrade/reference/gajs-analyticsjs
        const gaSetupOptions = {
            cookieDomain: 'auto',
            legacyCookieDomain: '.stripe.com'
        };
        // Configure Google Analytics
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.ga('create', 'UA-12675062-1', gaSetupOptions);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        setupGoogleAnalytics(window.ga, config.safeQueryParams);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.ga('require', 'displayfeatures');
        // Set loggedIn custom dimension to "true" or "false" if it is defined.
        if (config.googleAnalytics && typeof config.googleAnalytics.isLoggedIn !== 'undefined') {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.ga('set', 'dimension1', String(config.googleAnalytics.isLoggedIn));
        }
        // Set flags custom dimension.
        if (config.googleAnalyticsFlags) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            window.ga('set', 'dimension2', stringifyFlags(config.googleAnalyticsFlags));
        }
        // Track pageview
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        window.ga('send', 'pageview');
    }
};

//# sourceMappingURL=googleAnalytics.js.map